import * as S from "./styled";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import axiosInstance from "services/axiosInstance";
import { NumericFormat } from "react-number-format";
import { useAuth } from "context/AuthContext";
//Components
import LayoutModal from "../../../LayoutModal";
import { useEffect, useState } from "react";
//hooks
import apiRequest from "../../../../hooks/apiRequest";
import useLoading from '../../../../hooks/useLoading';
//Interface
import { Inputs, IExpense } from "Interfaces/IExpense";
//icons
import { FileArrowUp } from "@phosphor-icons/react";

interface ICreate {
  isOpenModal: boolean;
  setModalClose: () => void;
  refreshFrames: () => void;
  selectedUrlId: number | null;
}

export default function Update({
  isOpenModal,
  setModalClose,
  refreshFrames,
  selectedUrlId
}: ICreate) {
  const {
    register,
    reset,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm<Inputs>();

  const UserAuthenticated = useAuth();
  const [category, setCategory] = useState<IExpense["category_expenses"][]>([]);
  const { isLoading, startLoading, stopLoading } = useLoading();
  const [fileName, setFileName] = useState("Formato de entrada (.png, .pdf, .jpeg)");


  const fetchData = async () => {
    try {
      // const response = await axiosInstance.get('category-expense');
      const [response, responseCategory] = await Promise.all([
        axiosInstance.get(`expense/${selectedUrlId}`),
        axiosInstance.get('category-expense')
      ]);
      const addressData = response.data;
      setCategory(responseCategory.data);

      for (const key in addressData) {
        setValue(key as keyof Inputs, addressData[key]);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  useEffect(() => {
    if (isOpenModal) {
      fetchData();
    }
  }, [isOpenModal]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const response = await apiRequest(`expense/${selectedUrlId}`, 'PATCH', data);
      if (response.status === 200) {
        alert("Saída atualizada com sucesso!");
        refreshFrames();
        onClose();
      }
    } catch (error: any) {
      alert(error.message); // Exibe a mensagem de erro lançada pelo serviço
    } finally {
      stopLoading();
    }
  };

  const onClose = () => {
    setModalClose();
    reset();
  };

  const handleFileChange = (
    event: any,
    onChange: (...event: any[]) => void
  ) => {
    const files = event.target.files as FileList; // Asserção de tipo
    if (files && files.length > 0) {
      const fileNames = Array.from(files)
        .map((file: File) => file.name)
        .join(", ");
      setFileName(fileNames); // Define o nome dos arquivos como uma string separada por vírgulas
      onChange(files); // Passa a lista de arquivos para o react-hook-form
    } else {
      setFileName("Formato de entrada (.png, .pdf, .jpeg)");
    }
  };

  if (isOpenModal) {
    return (
      <LayoutModal
        statusLoad={isLoading}
        title="Atualizar Saída"
        subTitle="Cadastre uma nova saída em sua base de dados."
        setModalClose={onClose}
        submiteModal={handleSubmit(onSubmit)}
        nameSubmit="Atualizar"

        nameIconMinimize={'Atualizar Saída'}
        setMaximizeModal={fetchData}
      >
        <S.Container>
          <S.FormInput>
            <S.Label>
              Nome
              <span>*</span>
            </S.Label>
            <S.Input
              placeholder="Informe o nome da saída"
              type="text"
              {...register("title", { required: true })}
            />
            {errors.title && <S.InforErro>Campo Obrigatório</S.InforErro>}
          </S.FormInput>

          <S.FormInput>
            <S.Label>
              Categoria
              <span>*</span>
            </S.Label>
            <S.Select {...register("category_expense_id", { required: true })}>
              <option value="" disabled selected hidden>
                Selecione
              </option>
              {category.map((val) => {
                return <option value={val.id}>{val.category_expense}</option>;
              })}
            </S.Select>
            {errors.category_expense_id && (
              <S.InforErro>Campo Obrigatório</S.InforErro>
            )}
          </S.FormInput>

          <S.SeparateDiv>
            <S.FormInput>
              <S.Label>
                Valor
                <span>*</span>
              </S.Label>
              <Controller
                name="total_amount"
                control={control}
                rules={{ required: "Este campo é obrigatório" }}
                render={({ field: { onChange, value, ref } }) => (
                  <NumericFormat
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    fixedDecimalScale={true}
                    placeholder="R$ 0,00"
                    prefix="R$ "
                    value={value}
                    onValueChange={(values) => {
                      const purchaseValue = values.floatValue ?? 0;
                      onChange(purchaseValue); // Atualiza o valor de compra
                    }}
                    getInputRef={ref}
                  />
                )}
              />
              {errors.total_amount && <S.InforErro>Campo Obrigatório</S.InforErro>}
            </S.FormInput>

            <S.FormInput>
              <S.Label>
                Data
                <span>*</span>
              </S.Label>
              <S.Input
                placeholder="Informe a ponta"
                type="date"
                {...register("date_proof", { required: true })}
              />
              {errors.date_proof && <S.InforErro>Campo Obrigatório</S.InforErro>}
            </S.FormInput>
          </S.SeparateDiv>

          {/* Campo de Arquivo */}
          {/* <S.FormInput>
            <span className="labelInput">Anexar Comprovante</span>
            <S.InputFile>
              <FileArrowUp size={32} />
              <label className="labelFile" htmlFor="proofs">
                Escolher Arquivo
              </label>
              <Controller
                name="proofs"
                control={control}
                render={({ field: { onChange } }) => (
                  <input
                    type="file"
                    id="proofs"
                    accept=".png, .pdf"
                    multiple
                    onChange={(event) => handleFileChange(event, onChange)}
                  />
                )}
              />
              <span>{fileName}</span>
            </S.InputFile>
            {errors.proofs && (
              <span className="msgInputError">Este campo é obrigatório</span>
            )}
          </S.FormInput> */}
          {/* Fim Campo de Arquivo */}
        </S.Container>
      </LayoutModal>
    );
  }
  return null;
}
